import { Form, InputGroup, FormControlProps } from 'react-bootstrap';
import { BiSearch } from 'react-icons/bi';
import { MdClose } from 'react-icons/md';
import './styles.css';

interface Props extends FormControlProps {
  name: string;
  inputRef?: React.RefObject<HTMLInputElement>;
  useGrayBackground?: boolean;
  onClear?: () => void;
}

function ThSearchInput({
  inputRef,
  className,
  useGrayBackground = false,
  onClear,
  ...props
}: Props) {
  const sharedClasses = ['th-search-input'];
  if (useGrayBackground) {
    sharedClasses.push('th-search-input--gray');
  }

  const textClassName = sharedClasses.join(' ');
  const controlClassName = [...sharedClasses, className]
    .filter(Boolean)
    .join(' ');

  return (
    <InputGroup
      className={useGrayBackground ? 'th-search-input-group--gray' : undefined}
      style={{ position: 'relative' }}
    >
      <InputGroup.Text className={textClassName}>
        <BiSearch size={16} data-testid="bi-search" />
      </InputGroup.Text>
      <Form.Control className={controlClassName} ref={inputRef} {...props} />
      {onClear && props.value && (
        <MdClose
          className="th-search-input-clear cursor-point"
          onClick={onClear}
          data-testid="clear-search-icon"
        />
      )}
    </InputGroup>
  );
}

export default ThSearchInput;
